import styled from "@emotion/styled"
import { get } from "lodash"
import React from "react"
import tw from "twin.macro"
import linkTransformer from "../utils/linkTransformer"
import Button from "./Button"
import Link from "./Link"

const Container = styled.div`
  max-width: 900px;
  ${tw`mx-auto`}
`

const LinksWrapper = styled.div`
  ${tw`flex flex-wrap -mt-4 -ml-4`}
  ${(props) => props.align === "center" && tw`justify-center`}
`
const LinkItem = styled.div`
  ${tw`pl-4 mt-4`}
`

const Links = ({ links, linkType, align, contrastText }) => {
  return (
    <Container>
      <LinksWrapper align={align}>
        {links.map((link) => {
          const id = get(link, "system.id")
          return (
            <LinkItem key={id}>
              <LinkContentItem
                contentItem={link}
                linkType={linkType}
                contrastText={contrastText}
              />
            </LinkItem>
          )
        })}
      </LinksWrapper>
    </Container>
  )
}

export const LinkContentItem = ({ contentItem, linkType, contrastText }) => {
  const transformedLink = linkTransformer(contentItem)
  const size =
    {
      large: "lg",
    }[get(contentItem, "elements.size.value[0].codename")] || null
  const icon =
    {
      arrow: "long-arrow-alt-right",
    }[get(contentItem, "elements.icon.value[0].codename")] || null

  return (
    <Button
      type={linkType}
      to={transformedLink.to}
      target={transformedLink.openInNewWindow ? "_blank" : null}
      contrastText={contrastText}
      icon={icon}
      size={size}
      as={Link}
    >
      {transformedLink.label}
    </Button>
  )
}

export default Links
